export default __webpack_public_path__ + "media/angular.06e95d24.svg";